import axios from 'axios'

export default {
  getHomeDashboard (force = false) {
    return axios.get('/home?force=' + force)
  },
}
